import { AnchorButton } from "components/Button/AnchorButton";
import styles from "./ApiBanner.module.css";
import Image from "next/image";

export function ApiBanner() {
  return (
    <div className={styles.banner}>
      <div>
        <div className={styles.title}>
          <h1>
            Leave your data infrastructure to us:
            <br />
            Introducing the Dune API
          </h1>
          <AnchorButton href="/api" theme="primary" size="M">
            Learn more
          </AnchorButton>
        </div>

        <div className={styles.features}>
          <div>
            <h2>Execute queries</h2>
            <p>
              Create an API endpoint from any query and run queries
              programmatically.
            </p>
          </div>

          <div>
            <h2>Export data</h2>
            <p>Read structured data programmatically in JSON or CSV format.</p>
          </div>
          <div>
            <h2>Comprehensive coverage</h2>
            <p>
              Get fast, updated access to organised data across chains and
              protocols.
            </p>
          </div>
        </div>
      </div>

      <div className={styles.animation}>
        <Image
          src="/assets/Api_Data_Management.gif"
          alt="Example"
          width={500}
          height={500}
        />
      </div>
    </div>
  );
}
